import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { CLOUD_NORMAL, makeThemeColor, PRIMARY, QUINARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../utils/style';
import { identity } from '../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const PADDING = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const BORDER_RADIUS = {
  [HD]: 2,
  [FULL_HD]: 2,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  primary: makeThemeColor(CLOUD_NORMAL),
  secondary: makeThemeColor(QUINARY),
};

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const getLabelFont = screenSize => getFont(FONT.BOSTON_2, screenSize, TITLE_FONT_TYPE);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const font = getLabelFont(screenSize);
  const h = font.lineHeight + PADDING[screenSize] * 2;

  return _merge({
    h,
    Background: {
      h,
      color: colors.primary[colorMode],
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
      w: identity,
    },
    Label: {
      y: PADDING[screenSize],
      color: colors.text[colorMode],
      text: {
        ...font,
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
      },
    },
  });
};
